import { render } from "./PlanItemPremium.vue?vue&type=template&id=e5556152"
import script from "./PlanItemPremium.vue?vue&type=script&lang=js"
export * from "./PlanItemPremium.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/onboarding/PlanItemPremium.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5556152"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5556152', __exports__)) {
    api.reload('e5556152', __exports__)
  }
  
  module.hot.accept("./PlanItemPremium.vue?vue&type=template&id=e5556152", () => {
    api.rerender('e5556152', render)
  })

}


export default __exports__